/*
  cb-parts-collection.js - gedrag van de onderdelen-collectiepagina

  Hoort bij sections/cb-parts-collection.liquid. Alles hier is aankleding: de
  filters zijn een gewoon GET-formulier en de kaarten zijn gewone links, dus de
  pagina blijft bruikbaar als dit bestand niet laadt.

  Wat het script doet:
  - het productgrid ophalen zodra de onderdelenweergave opengaat, want op de
    kale hub rendert de server het niet mee (P1.3);
  - wisselen tussen de categorie- en onderdelen-weergave, en die keuze in de
    querystring zetten zodat delen en de terugknop kloppen;
  - het filterpaneel op mobiel openen en sluiten;
  - de teller op de Filters-knop meelopen met wat je aanvinkt;
  - op desktop het filter meteen toepassen, zonder knop;
  - de categorieen doorzoeken, op beginletter filteren en sorteren.

  Let op: `show` is de parameter voor de weergave, niet `view`. Shopify pakt
  `?view=` af om een ander template te laden.
*/
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1024px)';

  function init(root) {
    if (root.dataset.cbReady === 'true') { return; }
    root.dataset.cbReady = 'true';

    var tabs = root.querySelectorAll('[data-cb-view-tab]');
    var sheet = root.querySelector('[data-cb-filter-sheet]');
    var openBtn = root.querySelector('[data-cb-filter-open]');
    var countEl = root.querySelector('[data-cb-filter-count]');
    var serverCount = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;

    /* ---------- Grid pas ophalen als het nodig is ---------- */

    // Op de kale hub rendert de server het grid niet (zie de sectie, P1.3).
    // Opent iemand de onderdelenweergave, dan halen we alleen deze sectie op
    // via de Section Rendering API; `sort_by` in die URL laat de server het
    // grid wel renderen. Mislukt dat, dan blijft de gewone link staan.
    var lazy = root.querySelector('[data-cb-parts-lazy]');
    var lazyState = lazy ? 'idle' : 'done';

    function loadParts() {
      if (lazyState !== 'idle') { return; }
      lazyState = 'loading';
      window.fetch(lazy.dataset.src, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) { throw new Error('HTTP ' + response.status); }
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cb-parts-body]');
          var body = root.querySelector('[data-cb-parts-body]');
          if (!fresh || !body || fresh.querySelector('[data-cb-parts-lazy]')) {
            throw new Error('geen grid in het antwoord');
          }
          body.innerHTML = fresh.innerHTML;
          lazyState = 'done';
        })
        .catch(function () {
          lazyState = 'failed';
          var msg = lazy.querySelector('[data-cb-parts-lazy-msg]');
          if (msg) { msg.hidden = true; }
        });
    }

    /* ---------- Weergave ---------- */

    function currentView() {
      return root.classList.contains('cb-pc--view-parts') ? 'parts' : 'cats';
    }

    function setView(view, push) {
      root.classList.remove('cb-pc--view-cats', 'cb-pc--view-parts');
      root.classList.add('cb-pc--view-' + view);
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', tab.dataset.cbViewTab === view ? 'true' : 'false');
      });
      if (view === 'parts') { loadParts(); }
      if (!push) { return; }
      var url = new URL(window.location.href);
      url.searchParams.set('show', view);
      window.history.replaceState({}, '', url);
    }

    setView(currentView(), false);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setView(tab.dataset.cbViewTab, true);
      });
    });

    // Het grid alvast ophalen zodra iemand naar het tabblad beweegt, erop
    // tabt of het aanraakt; bij de klik is het dan meestal al binnen. Een
    // tweede aanroep doet niets, loadParts houdt zijn eigen stand bij.
    var partsTab = root.querySelector('[data-cb-view-tab="parts"]');
    if (partsTab && lazy) {
      ['pointerenter', 'focus', 'touchstart'].forEach(function (type) {
        partsTab.addEventListener(type, loadParts, { passive: true, once: true });
      });
    }

    // Staat er geen filterkolom, dan wijst de onderdelenweergave naar de
    // categorieen. Bewust geen tab-attribuut, anders zou setView deze knop ook
    // een aria-selected geven en dat is hij niet.
    var gotoCats = root.querySelector('[data-cb-goto-cats]');
    if (gotoCats) {
      gotoCats.addEventListener('click', function () {
        setView('cats', true);
        root.scrollIntoView({ block: 'start' });
      });
    }

    /* ---------- Filterpaneel op mobiel ---------- */

    function countChecked(form) {
      if (!form) { return serverCount; }
      var total = form.querySelectorAll('input[type="checkbox"]:checked').length;
      // De twee prijsvelden zijn samen een filter, net als in het resultaatlabel.
      var filled = 0;
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        if (input.value !== '') { filled += 1; }
      });
      if (filled > 0) { total += 1; }
      return total;
    }

    function paintCount(value) {
      if (!countEl) { return; }
      countEl.textContent = value;
      countEl.hidden = value === 0;
      if (openBtn) { openBtn.classList.toggle('is-on', value > 0); }
    }

    if (sheet && openBtn) {
      var sheetForm = sheet.querySelector('[data-cb-filter-form]');

      var openSheet = function () {
        sheet.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = sheet.querySelector('[data-cb-filter-close]');
        if (close && close.focus) { close.focus(); }
      };

      var closeSheet = function () {
        sheet.hidden = true;
        document.body.style.overflow = '';
        paintCount(serverCount);
        openBtn.focus();
      };

      openBtn.addEventListener('click', openSheet);

      sheet.querySelectorAll('[data-cb-filter-close]').forEach(function (el) {
        el.addEventListener('click', closeSheet);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !sheet.hidden) { closeSheet(); }
      });

      if (sheetForm) {
        sheetForm.addEventListener('change', function () {
          paintCount(countChecked(sheetForm));
        });
        sheetForm.addEventListener('input', function () {
          paintCount(countChecked(sheetForm));
        });
      }
    }

    /* ---------- Filter op desktop meteen toepassen ---------- */

    var aside = root.querySelector('.cb-pc__aside [data-cb-filter-form]');
    if (aside) {
      var priceTimer = null;

      aside.addEventListener('change', function (event) {
        if (!window.matchMedia(DESKTOP).matches) { return; }
        if (event.target.type === 'number') { return; }
        aside.submit();
      });

      // Prijs pas versturen als het typen even stilligt, anders herlaadt de
      // pagina bij elk cijfer.
      aside.addEventListener('input', function (event) {
        if (event.target.type !== 'number') { return; }
        if (!window.matchMedia(DESKTOP).matches) { return; }
        window.clearTimeout(priceTimer);
        priceTimer = window.setTimeout(function () { aside.submit(); }, 700);
      });
    }

    /* ---------- Sorteren ---------- */

    var sortParts = root.querySelector('[data-cb-sort-parts]');
    if (sortParts && sortParts.form) {
      sortParts.addEventListener('change', function () { sortParts.form.submit(); });
    }

    /* ---------- Categorieen: zoeken, letters, sorteren ---------- */

    var grid = root.querySelector('[data-cb-cat-grid]');
    if (!grid) { return; }

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cb-cat]'));
    var search = root.querySelector('[data-cb-cat-search]');
    var lettersWrap = root.querySelector('[data-cb-letters]');
    var sortCats = root.querySelector('[data-cb-sort-cats]');
    var emptyMsg = root.querySelector('[data-cb-cat-empty]');
    var activeLetter = '*';

    // De letterknoppen komen uit de kaarten zelf, zodat er nooit een letter
    // zonder resultaat tussen staat.
    if (lettersWrap) {
      var seen = Object.create(null);
      cards.forEach(function (card) {
        var letter = card.dataset.catLetter;
        if (letter && !seen[letter]) { seen[letter] = true; }
      });
      Object.keys(seen).sort().forEach(function (letter) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cb-pc__letter';
        button.dataset.letter = letter;
        button.textContent = letter;
        lettersWrap.appendChild(button);
      });

      lettersWrap.addEventListener('click', function (event) {
        var button = event.target.closest('.cb-pc__letter');
        if (!button) { return; }
        activeLetter = button.dataset.letter;
        lettersWrap.querySelectorAll('.cb-pc__letter').forEach(function (el) {
          el.classList.toggle('is-on', el === button);
        });
        apply();
      });
    }

    function apply() {
      var query = search ? search.value.trim().toLowerCase() : '';
      var visible = cards.filter(function (card) {
        var nameHit = !query || card.dataset.catName.indexOf(query) !== -1;
        var letterHit = activeLetter === '*' || card.dataset.catLetter === activeLetter;
        return nameHit && letterHit;
      });

      var mode = sortCats ? sortCats.value : 'count';
      visible.sort(function (a, b) {
        if (mode === 'az') { return a.dataset.catName.localeCompare(b.dataset.catName); }
        if (mode === 'za') { return b.dataset.catName.localeCompare(a.dataset.catName); }
        return parseInt(b.dataset.catCount, 10) - parseInt(a.dataset.catCount, 10);
      });

      cards.forEach(function (card) { card.hidden = true; });

      var fragment = document.createDocumentFragment();
      visible.forEach(function (card) {
        card.hidden = false;
        fragment.appendChild(card);
      });
      grid.appendChild(fragment);

      if (emptyMsg) { emptyMsg.hidden = visible.length !== 0; }
    }

    if (search) { search.addEventListener('input', apply); }
    if (sortCats) { sortCats.addEventListener('change', apply); }

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-cb-parts-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // De theme-editor bouwt een sectie opnieuw op zonder de pagina te herladen.
  document.addEventListener('shopify:section:load', boot);
})();
